<template>
    <div class="login-container">
        <div class="loginForm">
            <h2>로그인</h2>
            <form @submit.prevent="login">
                <div class="inputBox">
                    <label for="id">아이디</label>
                    <input v-model="loginid" type="text" id="id" placeholder="아이디" required />
                </div>
                <div class="inputBox">
                    <label for="password">비밀번호</label>
                    <input v-model="password" type="password" id="password" placeholder="비밀번호" required />
                </div>
                <div class="login_option">
                    <div>
                        <input v-model="saveId" type="checkbox" id="saveId" />
                        <label for="saveId">아이디 저장</label>
                    </div>
                    <div>
                        <input v-model="autoLogin" type="checkbox" id="autoLogin" />
                        <label for="autoLogin">자동 로그인</label>
                    </div>
                </div>
                <div class="loginBtn">
                    <button type="submit">로그인</button>
                </div>
                <div class="find">
                    <!-- <a :href="privacyURL" class="privacy">개인정보처리방침</a> -->
                    <div><router-link to="/findID">아이디</router-link> • <router-link to="/findPW">비밀번호</router-link> 찾기</div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { supabase } from '@/API/supabase';
import VueCookies from 'vue-cookies';

export default {
    data() {
        return {
            loginid: '',
            password: '',
            user: null,
            saveId: false,
            autoLogin: false,
            privacyURL:''
        };
    },
    mounted() {
        // this.$store.commit("logoutUser");
        // if (window.location.hostname.includes('ringosos')) {
        //     this.privacyURL = 'https://www.ringosos.co.kr/privacy_ringobell'; //링고벨
        // } else {
        //     this.privacyURL = 'https://syscallsafe.com/privacy'; //씨스콜
        // }

        // 저장된 아이디 불러오기
        const getSavedId = localStorage.getItem('savedNttWebId');
        if (getSavedId) {
            this.loginid = getSavedId;
            this.saveId = true;
        }

        // 자동 로그인 상태 확인
        const autoLogin = VueCookies.get('autoLogin');
        if (autoLogin === 'true') {
            this.autoLogin = true;
        }
    },
    methods: {
        // 로그인
        async login() {
            if (this.loginid == '') {
                await this.$alert('아이디를 입력해주세요.', '알림');
                return;
            }
            if (this.password == '') {
                await this.$alert('비밀번호를 입력해주세요.', '알림');
                return;
            }

            var isCheck = await this.checkUserAccount();

            if(!isCheck){
                await this.$alert('아이디 또는 비밀번호가 일치하지 않습니다.', '알림');
                return;
            }

            var params = {
                loginid: this.loginid,
                password: this.password,
            };

            var authLogin = this.autoLogin;

            this.$store
                .dispatch('UserAccountStore/login', params)
                .then(async (res)  => {
                    // console.log(res);
                    if (res.success) {
                        var userInfo = {
                            access_token: res.accesstoken,
                            refresh_token: res.refreshtoken,
                            user_id: res.resultdata.user_id,
                            autoLogin: authLogin,
                        };

                        // console.log("userInfo: ",userInfo);

                        // 아이디 저장 체크시
                        if (this.saveId) {
                            localStorage.setItem('savedNttWebId', this.loginid);
                        } else {
                            localStorage.removeItem('savedNttWebId');
                        }

                        this.getUserInfo(userInfo);
                    } else {
                        console.error(res.message);
                        await this.$alert(res.message, '알림');
                    }
                    return res;
                })
                .catch(({ message }) => console.error(message));
        },

        // 사용자 계정 확인
        async checkUserAccount() {
            var isCheck = false;

            let query = supabase
                .from('UserInfo')
                .select(
                    `isdelete`
                )
                .eq('loginid', this.loginid)
                .single();

            const { data: userData, error } = await query;
            if (error) {
                console.error('error', error);
            } else {
                // console.log(userData);
                if (userData) {
                    if (!userData.isdelete) {
                        isCheck = true;
                    }
                }
            }

            return isCheck;
        },

        // 사용자 정보 가져오기
        getUserInfo(userInfo) {
            var params = {
                user_id: userInfo.user_id,
            };

            this.$store
                .dispatch('UserAccountStore/getUserData', params)
                .then((res) => {
                    // console.log("res2",res);
                    if (res.success) {
                        var userData = res.resultdata;
                        userInfo['display_name'] = userData.Display;
                        userInfo['user_name'] = userData.user_name;
                        userInfo['comp_id'] = userData.comp_id;
                        userInfo['auth'] = userData.auth;
                        userInfo['thumb'] = userData.thumb;
                        userInfo['emr_color'] = userData.emr_alr_color;
                        userInfo['stt_color'] = userData.stt_alr_color;
                        userInfo['melody'] = userData.melody;
                        userInfo['sound'] = userData.sound;
                        userInfo['rows_per_page'] = userData.rows_per_page;

                        this.$store.commit('setLoggedIn', true);
                        this.$store.commit('setUser', userInfo);
                        this.sendUserIdToFlutter(userInfo.user_id);

                        if (userData.auth == '0' || userData.auth == '1') {
                            this.$router.push('/admin');
                        } else {
                            this.$router.push('/');
                        }
                    } else {
                        console.error(res.message);
                    }
                    return res;
                })
                .catch(({ message }) => console.error(message));
        },

        // 플러터로 사용자 ID 전송
        sendUserIdToFlutter(userId) {
            if (window.FlutterChannel) {
                window.FlutterChannel.postMessage(userId);
            }
        },
    },
};
</script>
